export default __webpack_public_path__ + "media/images/deserts-e109ec73306646df41dea78de076d45d.png";